import { render, staticRenderFns } from "./PreCadastro.vue?vue&type=template&id=10358d31"
import script from "./PreCadastro.vue?vue&type=script&lang=js"
export * from "./PreCadastro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports